import React, { FC, memo } from 'react';

export const StepDivider: FC = memo(() => {
  return <div className="mr-6 h-[1px] w-8 bg-secondaryAccent rounded-full shrink-0" />;
});
